import {createContext, useContext, useState} from "react";

const AlertContext = createContext(false);

export const AlertProvider = ({ children }) => {
  const [state, setState] = useState({
    isOpen: false,
    // Type can be either "success" or "error"
    type: 'success',
    // Message to be displayed, can be any string
    txt: '',
  });

  return (
    <AlertContext.Provider
      value={{
        ...state,
        onOpen: (type, txt) => setState({ isOpen: true, type, txt }),
        onClose: () => setState({ isOpen: false, type: '', txt: '' }),
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export const useAlertContext = () => useContext(AlertContext);
